import { useState, useRef, useEffect } from 'react';
import getXcolumnJson from "./xcolumn/list";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup_portal';
import TradeWriteMultyPopup from "@/pages/comp/supply/simple_trade/popup/write_multy";
import ExcelDownComponent from "@/pcomponents/common/excel/down";
import SearchArea from "./area/search";
import SumTableArea from "./area/sum_table";
import ListArea from "./area/list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";

function ListMoneyArea(props: any) {
  let myProps = {
    ...props
  };
  const xColumnArr = getXcolumnJson();
  const excelDownRef = useRef<any>(null);
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState<any>({ "tot": 0 });
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    "s_date_type": "a_date",
    "s_start_date": DateFunc.get_date_format(new Date(), "Y-m-01"),
    "s_end_date": DateFunc.get_date_format(new Date(), "Y-m-t"),
    "s_cust_par_id": "",
    "s_cust_par_seq": [],
    "s_money_type": "money",
    "s_inout": "",//in, out
    "s_cust_name_like": "",
    "s_subject_detail_like": "",
    "s_memo_like": "",
    "s_addon_cust_name": "1",
    "s_money_sum": "1",
  });
  const [select_row_num_arr, set_select_row_num_arr] = useState<any>([]);

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "write_multy",//find
    cust_par_id: "",
    cust_par_seq: "",
    cust_name: "",
    a_subject_detail: "",
    title: "팝업",
    width: "800px",
    height: "80%",
  });

  useEffect(() => {
    list({});
  }, []);

  const list = (inData: any) => {
    let change_listOpt = {
      ...listOpt,
      ...inData
    };
    setListOpt(change_listOpt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/list', change_listOpt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          response.data["data"]["info_arr"] = [...response.data["data"]["info_arr"].reverse()];
          setInfoArr(response.data["data"]["info_arr"]);

          response.data["data"]["count_info"]["row_view_money_in"] = strFunc.comma(response.data["data"]["count_info"]["row_view_money_in"]);
          response.data["data"]["count_info"]["row_view_money_out"] = strFunc.comma(response.data["data"]["count_info"]["row_view_money_out"]);
          let in_out_total = parseInt(strFunc.uncomma(response.data["data"]["count_info"]["row_view_money_in"])) - parseInt(strFunc.uncomma(response.data["data"]["count_info"]["row_view_money_out"]));
          response.data["data"]["count_info"]["in_out_total"] = strFunc.comma(in_out_total);
          setCountInfo(response.data["data"]["count_info"]);
        } else {

        }
      });
  };

  const get_selected_info_arr = (inData: any) => {
    let opt_obj = {
      info_arr: infoArr,
      select_row_num_arr: select_row_num_arr,
      ...inData
    };
    let selected_arr: any = [];
    for (let i = 0; i < opt_obj.info_arr.length; i++) {
      let row_data = opt_obj.info_arr[i];
      let row_num = i + "";
      if (strFunc.str_in_array(row_num, opt_obj.select_row_num_arr) != -1) {
        selected_arr.push(row_data);
      }
    }
    return selected_arr;
  };

  const goDelete = () => {
    let selected_arr: any = get_selected_info_arr({});
    if (selected_arr.length === 0) {
      alert("선택없음.");
      return false;
    }
    //걸러내자
    for (let i = 0; i < selected_arr.length; i++) {
      let row_data = selected_arr[i];
      if (row_data["a_par_id"] == "class_supply" && !strFunc.is_empty(row_data["a_par_seq"])) {
        alert("청구서관련 데이터는 삭제 할 수 없습니다.(수납관리에서 수정해주세요.)");
        return false;
      }
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/trade/trade_simple/delete', {
      data_arr: selected_arr
    }, get_axios_data()).then((response) => {
      if (response.data["result"] === "true") {
        list({});
      } else {
        alert(response.data["msg"]);
      }
    });
  };

  const openWriteMultyPopup = () => {

    setPopupData({
      ...popupData,
      "cust_par_id": "trade_cust",
      "cust_par_seq": "",
      "cust_name": "",
      "title": "등록",
      "sort": "write_multy",
      "isOpen": true,
    });
  };

  const go_excel_down_list = () => {
    if (excelDownRef.current) {
      excelDownRef.current.setInitData({
        xColumnArr: xColumnArr,
        is_add_example: false,
        infoArr: infoArr,
        excelFileName: "입출금" + DateFunc.get_date_format(new Date(), "Ymd_his"),
      });
      setTimeout(() => {
        excelDownRef.current.goDownExcel();
      }, 100);
    }
  };

  const excel_customCellRenderer = (inOpt: any) => {
    let opObj = {
      "rowData": {},
      "idx": 0,
      "key": "",
      "value": "",
      ...inOpt
    };
    let val_str: any = opObj.value;
    let key = opObj.key;
    let info = opObj.rowData;

    if (key == "row_view_money_in") {
      if (info.a_inout == "in" && info.a_money_type == "money") {
        val_str = info.a_money;
      }
    } else if (key == "row_view_debt_in" && info.a_money_type == "debt") {
      if (info.a_inout == "in") {
        val_str = info.a_money;
      }
    } else if (key == "row_view_money_out") {
      if (info.a_inout == "out" && info.a_money_type == "money") {
        val_str = info.a_money;
      }
    }

    return val_str;
  };

  return (
    <div>
      <SearchArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        list={list}
      ></SearchArea>
      <SumTableArea
        countInfo={countInfo}
        openWriteMultyPopup={openWriteMultyPopup}
        goDelete={goDelete}
        go_excel_down_list={go_excel_down_list}
      ></SumTableArea>
      <div className="mt-1">
        <ListArea
          xColumnArr={xColumnArr}
          infoArr={infoArr}
          setInfoArr={setInfoArr}
          select_row_num_arr={select_row_num_arr}
          set_select_row_num_arr={set_select_row_num_arr}
        ></ListArea>
        <Paging now_page={listOpt.now_page}
          num_per_page={listOpt.num_per_page}
          total_rec={countInfo.tot}
          onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
          onChangeNumPerPage={(num_per_page: number) => { list({ num_per_page: num_per_page, now_page: 1 }); }}></Paging>
      </div>
      <ExcelDownComponent
        ref={excelDownRef}
        xColumnArr={xColumnArr}
        is_add_example={false}
        customCellRenderer={excel_customCellRenderer}
      ></ExcelDownComponent>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {
            popupData.sort == "write_multy" &&
            <TradeWriteMultyPopup
              cust_par_id={popupData.cust_par_id}
              cust_par_seq={popupData.cust_par_seq}
              cust_name={popupData.cust_name}
              a_subject_detail={popupData.a_subject_detail}
              is_show_cust_name={true}
              is_show_money_type={false}
              is_show_in_out={false}
              add_btn_arr={[
                { "a_inout": "in", "a_memo": "수입", "a_money_type": "money" },
                // {"a_inout":"in","a_memo":"청구","a_money_type":"debt"},
                { "a_inout": "out", "a_memo": "지출", "a_money_type": "money" },
              ]}
              callBackData={() => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
            ></TradeWriteMultyPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default ListMoneyArea;